/*
 * @fileoverview Simple in-flight promise deduplication helper
 *
 * Keeps a module-level Map of operation keys -> Promise so that identical
 * async operations fired concurrently share the same network request.
 */
const inFlight = new Map();
/**
 * Runs the supplied async `operation` while preventing duplicate executions.
 *
 * If a promise for the same `key` is already in-flight we return that promise
 * instead of calling `operation` again.
 *
 * The entry is removed once the promise settles (resolve or reject).
 */
export function runWithDedup(key, operation) {
    if (inFlight.has(key)) {
        return inFlight.get(key);
    }
    const promise = operation().finally(() => {
        inFlight.delete(key);
    });
    inFlight.set(key, promise);
    return promise;
}
/**
 * Clears a specific in-flight operation by key
 * Useful when you need to force a fresh request (e.g., after token change)
 */
export function clearDedup(key) {
    inFlight.delete(key);
}
